import React, { useState, useEffect } from "react";
import CreateCourse from './CreateCourse';
import CourseList from './CourseList';
import { PopupModel, Input } from "../../shared";
import { Col, Row } from "react-bootstrap";
import { levelConfig, getSession,setSession } from '../../../utils/utils';

export default function AddManageCourse() {
  const [levelForm, setLevelForm] = useState({});
  const [askLevel, setAskLevel] = useState(true);
  useEffect(() => {
    const stored = getSession('levelForm');
    if (stored) {
      setLevelForm(stored);
      setAskLevel(false);
    } else {
      setLevelForm({
        videoLevel: '',
        questionLevel: '',
        courseLevel: ''
      });
    }
  }, []);

  return (
    askLevel ?
      <>
        <div style={{ height: '80vh' }}></div>
        <PopupModel
          size='lg'
          showModal={askLevel}
          handleCloseModal={() => setAskLevel(false)}
          title={<><span className="d-block">Customize your Learning path</span><span className="d-block text-muted" style={{ fontSize: '0.8rem', fontWeight: 'normal' }}>Chose the appropriate levels for Video, Assessment and Course to get personalized recommendations </span></>}
          footerContent={<button
            className='btn'
            title="Save & Continue"
            onClick={() => {
              setAskLevel(false);
              setSession('levelForm', levelForm);
            }}
            style={{ backgroundColor: 'var(--baseblue)', color: 'var(--white)' }}
          >
            Save & Continue
          </button>}
        >
          <Row>
            <Col md={4} xs={12}>
              <Input
                label="Video Difficulty Level"
                type="select"
                name="videoLevel"
                value={levelForm.videoLevel}
                onChange={(e) => setLevelForm({ ...levelForm, videoLevel: e.target.value })}
                options={levelConfig}
              />
            </Col>
            <Col md={4} xs={12}>
              <Input
                label="Question Difficulty Level"
                type="select"
                name="questionLevel"
                value={levelForm.questionLevel}
                onChange={(e) => setLevelForm({ ...levelForm, questionLevel: e.target.value })}
                options={levelConfig}
              />
            </Col>
            <Col md={4} xs={12}>
              <Input
                label="Course Difficulty Level"
                type="select"
                name="courseLevel"
                value={levelForm.courseLevel}
                onChange={(e) => setLevelForm({ ...levelForm, courseLevel: e.target.value })}
                options={levelConfig}
              />
            </Col>
          </Row>
        </PopupModel>
      </>
      :
      <>
        <CreateCourse levels={levelForm} />
        <CourseList showcourse='all' />

      </>
  );
}